import { Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { NgIf } from '@angular/common';

@Component({
	selector: 'app-detection-error-modal',
	standalone: true,
	imports: [TranslateModule, NgIf],
	templateUrl: './detection-error-modal.component.html',
	styleUrls: ['./detection-error-modal.component.scss', './detection-error-modal.responsive.scss'],
})
export class DetectionErrorModalComponent {
	static readonly ID = crypto.randomUUID();

	type: 'detection_error' | 'fit_blind_error';
	translate: { [propName: string]: string };

	constructor(
		@Inject(MAT_DIALOG_DATA) public data: { type: 'detection_error' | 'fit_blind_error' },
		private dialogRef: MatDialogRef<DetectionErrorModalComponent>,
		private translateService: TranslateService,
	) {
		this.type = data.type;
		this.translationHandler();
	}

	closeDialog(method: string): void {
		this.dialogRef.close({ source: method });
	}

	translationHandler(): void {
		this.translateService
			.get([
				`modals.${this.type}.title`,
				`modals.${this.type}.subtitle`,
				'modals.detection_error.buttons.close',
				'modals.fit_blind_error.buttons.close',
			])
			.subscribe((translations) => (this.translate = translations));
	}
}
